
<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-05-06 09:45:07
 * @LastEditTime : 2025-06-23 13:53:35
 * @LastEditors  : yangxr
 * @Description 材料进销存
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\docking\incomeSheet\saleMonthReport.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main v-loading="mainLoading" style="display: flex">
        <div>
          <div class="search">
            <span style="display: inline-block; margin-bottom: 10px">
              <span style="margin-right: 12px">时间</span>
              <el-date-picker v-model="tableParams.businessTime" style="width: 150px;" type="month" unlink-panels
                value-format="yyyy-MM" start-placeholder="开始时间" end-placeholder="结束时间" @change="getBasicDataNew()"></el-date-picker>
            </span>
            <span style="margin-left: 24px">
              <span style="margin-right: 12px">站点</span>
              <el-select ref="selection" v-model="tableParams.stationIds" style="width: 250px" multiple filterable
                clearable>
                <el-option v-for="item in stationList" :key="item.stationId" :label="item.stationName"
                  :value="item.stationId"></el-option>
              </el-select>
            </span>
            <span style="margin-left: 24px">
              <span style="margin-right: 12px">主体</span>
              <el-select ref="mianBodyId" v-model="tableParams.mianBodyId" style="width: 200px" filterable clearable
                @change="$nextTick(() => { tableParams.mianBody = $refs.mianBodyId.selectedLabel });getBasicDataNew()" >
                <el-option v-for="item in mainBodyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </span>
            <el-button style="margin-left: 24px" icon="el-icon-search" size="medium" class="bottom_all"
              @click="getBasicData()">查 询</el-button>
            <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
            <el-button icon="el-icon-plus" size="medium" class="bottom_all" style=" position: absolute;right: 50px;"
              @click="generateForm()">生成收入报账单</el-button>
          </div>
          <div class="hr"></div>
          <div v-loading="tableLoading" :style="style">
            <div id="html-img">
            <tableMain id="approvalFormTableMain" ref="approvalFormTableMain" key="approvalFormTableMain" :tableData="tableData" :height="tableHeight"
              :tableHead="tableHead" :isImg="false" />
              </div>
          </div>
          <!-- 截图数据 -->
    <!-- <div id="html-img" style="position: fixed; top: -10000px;left:10000px;overflow:hidden;">
      <tableMain id="approvalFormTableMain" :ref="`approvalFormTableMain`" :key="`approvalFormTableMain`"
        :tableData="tableData" :tableHead="tableHead" :isImg="true" />
    </div> -->
          <!-- 业务记账单 -->
          <approvalForm ref="approvalForm" :dialog.sync="approvalFormDialog" :params="tableParams"
            @openDialog="openDialog" @resetForm="resetForm" @mainLoadingClose="mainLoadingClose" />
        </div>
      </el-main>
    </el-container>

  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import tableMain from "./tableMain.vue";
import html2canvas from 'html2canvas';
import { uploadFile } from "@/api/common.js";
import approvalForm from ".//report/approvalForm";
import { queryAllStation, querymainBodyList, queryBasicDataIncome } from "@/api/docking.js";
export default {
  components: {
    tableMain,
    approvalForm
  },
  mixins: [mixin],
  data() {
    return {
      pagesType: 0,
      tableParams: {
        businessTime: "",//日期(必传)
        mianBodyId: "",
        mianBody: "",
        stationIds: [],
        modeType: "", //模式（非必传，模式: 1 购买；2委托加工）
      },
      tableData: [],
      tableHead: [],
      tableData1: [],//生成图片所需数据
      tableData2: [],//生成图片所需数据
      mainBodyList: [],
      stationList: [],
      tableLoading: false,
      mainLoading: false,
      accountingFormDig: false,
      accountingForm: {},
      accountingFormRules: {},
      approvalFormDialog: false,
      imgStatus: 0,//0未生成 1已生成1个 2已生成完成
      tableHeight:"",
    };
  },
  watch: {
  },
  async created() {
    queryAllStation().then(res => {
      if (res.code == 1001) {
        this.stationList = res.data
      }
    })
    querymainBodyList().then(res => {
      if (res.code == 1001) {
        this.mainBodyList = res.data
      }
    })
    const query = this.$route.query
    if (query.mainBodyId && query.businessTime && query.mainBodyName) {
      this.tableParams.mianBody = query.mainBodyName
      this.tableParams.mianBodyId = query.mainBodyId
      this.tableParams.businessTime = query.businessTime
      this.getBasicData()
    }
  },
  mounted(){
    this.tableHeight = this.screenHeight - 260 + 'px'
  },
  methods: {
    openDialog() {
      this.approvalFormDialog = true
      this.mainLoadingClose()
    },
    mainLoadingClose() {
      this.mainLoading = false
    },
    resetForm() {
      this.approvalFormDialog = false
    },
    async generateImg() {
      await this.$nextTick();

      return new Promise((resolve, reject) => {
        const printContent = this.$refs[`approvalFormTableMain`].$el;
        const bodyWrapper = printContent.querySelector('.vxe-table--body' );
        const headerNode = printContent.querySelector('.vxe-table--header');
        const footerNode = printContent.querySelector('.vxe-table--footer');

        
        const computedStyle = window.getComputedStyle(printContent);
        const oldBodyHeight = computedStyle.height;
        const oldBodyWidth = computedStyle.width;

        const oldHtmlDemoStyle = {
            height: document.getElementById('html-img').style.height,
            width: document.getElementById('html-img').style.width,
        };

          // 获取当前 tableHeight 值
        const currentTableHeight = this.tableHeight;
        console.log('原始 tableHeight:', currentTableHeight);
        // 设置新的宽高以适配完整内容
        const newHeight = bodyWrapper.scrollHeight + (headerNode?.scrollHeight || 0) + (footerNode?.scrollHeight || 0);
        const newWidth = bodyWrapper.scrollWidth +40;


        document.getElementById('html-img').style.width = `${newWidth}px`;
        document.getElementById('html-img').style.height = `${newHeight}px`;
         // 修改 Vue 中的响应式 tableHeight
         this.tableHeight =  `${newHeight}px`;
         console.log(this.tableHeight)
         console.log(oldBodyHeight)
        // 同时设置 DOM 样式（用于 html2canvas 截图）
        printContent.setAttribute('style', `height: ${newHeight}px; width:${newWidth}px;`);
        setTimeout(() => {
          html2canvas(printContent, {
          scale: 1,
                width: newWidth,
                height: 2000,
        }).then(canvas => {
          canvas.toBlob(blob => {
            if (!blob) {
              return reject(new Error('canvas.toBlob 返回了 null'));
            }
            const file = new File([blob], "收入报账单.jpg", { type: "image/jpg" });
            const params = new FormData();
            params.append("file", file);

            uploadFile(params).then(res => {
              if (res.code === 1001) {
                res.data.fileUrl = 'https://lvshe.huashijc.com/file/' + res.data.fileUrl;
                let obj = [{
                  name: res.data.fileName,
                  url: res.data.fileUrl
                }]
                this.tableParams.files = JSON.stringify(obj)
                // this.formVal.detailVos[index].attachmentUrl = JSON.stringify(obj)
                this.$refs.approvalForm.initData()
                console.log(res.data.fileUrl);
                resolve(res.data);
              } else {
                this.mainLoadingClose = false
                reject(new Error('上传失败，code=' + res.code));
              }
            }).catch(err => {
              this.mainLoadingClose = false
              this.$emit("mainLoadingClose")
              reject(err)
            }
            
            );
          });
        }).catch(err => {
          this.mainLoadingClose = false
          this.$emit("mainLoadingClose")
          reject(err)
        }
        ).finally(() => {
                // 恢复原始样式和Vue数据
                document.getElementById('html-img').style.width = oldHtmlDemoStyle.width;
                document.getElementById('html-img').style.height = oldHtmlDemoStyle.height;
                printContent.setAttribute('style', `height: ${oldBodyHeight}; width: ${oldBodyWidth};`);
                this.tableHeight = oldBodyHeight;
                console.log(oldBodyHeight)
            });
        },500)
       
      });
    },
    async generateForm() {
      if(this.tableData.length == 0 ){
        this.$message.warning('请先查询列表数据')
        return
      }
      this.tableParams.files = ""
      this.$refs.approvalForm.initData()
      // this.mainLoading = true
      // await this.generateImg();
    },
    getBasicDataNew(){
      if (!this.tableParams.businessTime) {
        return
      }
      if (!this.tableParams.mianBodyId) {
        return
      }
      this.getBasicData()
    },
    async getBasicData(isImg) {
      if (!this.tableParams.businessTime) {
        this.$message.warning('时间不能为空！')
        this.tableLoading = false
        return
      }
      if (!this.tableParams.mianBodyId) {
        this.$message.warning('主体不能为空！')
        this.tableLoading = false
        return
      }
      this.tableLoading = true
      let res = await queryBasicDataIncome(this.tableParams)
      if (res.code == 1001) {
        res.data.sort((a, b) => {
          // 依次比较站点、时间、主体、大类
          // if (a.stationName !== b.stationName) {
          //   return a.stationName.localeCompare(b.stationName);
          // }
          // if (a.businessTime !== b.businessTime) {
          //   return a.businessTime.localeCompare(b.businessTime);
          // }
          // if (a.mianBodyName !== b.mianBodyName) {
          //   return a.mianBodyName.localeCompare(b.mianBodyName);
          // }
          return a.engineeringId.localeCompare(b.engineeringId);
        });
        let tableHead = []
        let tableData = []
        res.data.forEach(item => {
          //提取站点表头
          let headObj = { label: item.settleStationName, prop: item.settleStationName + 'quantity', status: true, width: "70" }
          if (!tableHead.some(item2 => item2.label === item.settleStationName)) {
            tableHead.push(headObj)
          }
          //合并表格数据
          const index = tableData.findIndex(item2 =>
            item2.engineeringId === item.engineeringId && item2.productName === item.productName
          );
          if (index == -1) {
            let obj = item
            obj['quantityAll'] = obj.quantity
            obj['taxInclusiveAmountAll'] = obj.taxInclusiveAmount
            obj[item.settleStationName + 'quantity'] = obj.quantity
            tableData.push(item)
          } else {
            tableData[index]['quantityAll'] = tableData[index]['quantityAll'] + item.quantity
            tableData[index]['taxInclusiveAmountAll'] = tableData[index]['taxInclusiveAmountAll'] + item.taxInclusiveAmount
            tableData[index][item.settleStationName + 'quantity'] = item.quantity
          }
        });

        console.log(tableHead)
        console.log(tableData)
        this.tableData = tableData
        this.tableHead = tableHead
        if(isImg){
          await this.generateImg();
        }
      }
      this.tableLoading = false
    },
    init() {
      this.tableParams = this.$options.data().tableParams
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}

.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
</style>
